import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// import OneSignal from 'react-onesignal';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import { useSettingsContext } from '../../components/settings';
//
import Main from './Main';
import Header from './header';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';
import NavHorizontal from './nav/NavHorizontal';
import Footer from './Footer';
import '../../pages/style/style.css';
import { runOneSignal } from '../../pushNotification/runOneSignal';

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { themeLayout } = useSettingsContext();
  const [initialized, setInitialized] = useState(true);

  useEffect(() => {
    if (initialized) {
      console.log('init onesignal');
      runOneSignal(setInitialized);
    }
  });

  const isDesktop = useResponsive('up', 'lg');

  const [open, setOpen] = useState(false);

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderNavVertical = <NavVertical openNav={open} onCloseNav={handleClose} />;

  if (isNavHorizontal) {
    return (
      <>
        <Header onOpenNav={handleOpen} />

        {isDesktop ? <NavHorizontal /> : renderNavVertical}

        <Main>
          <Outlet />
        </Main>
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={handleOpen} />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: isNavMini?  1 : 'calc(100% - 52px)'},
          transition: "width 120ms linear 0ms"
        }}
      >
        {isDesktop && isNavMini ? <NavMini /> : renderNavVertical}

        <Main>
          <Outlet />
        </Main>
      </Box>
      {
        !isNavMini && <Footer />
      }
    </>
    );
}
